import type { TrainingGroupRef } from "@/api";

// team 스코프에서 마지막으로 고른 그룹을 uid 단위로 localStorage 에 기억한다. 딥링크(?group=)가 없으면
// 이 값을 기본 선택으로 복원한다. 그래서 매번 팀을 다시 고르지 않는다. 같은 브라우저의 다른 사용자와
// 섞이지 않도록 uid 로 키를 나눈다. 저장 실패(프라이빗 모드·quota)는 알리지 않고 무시한다.
const storageKeyPrefix = "hatchery-registry:team-training:last-group";

function storageKey(uid: string): string {
  return `${storageKeyPrefix}:${uid}`;
}

export function loadLastTeam(uid: string | null): string | null {
  if (uid == null || typeof window === "undefined") {
    return null;
  }
  try {
    return window.localStorage.getItem(storageKey(uid));
  } catch {
    return null;
  }
}

export function saveLastTeam(uid: string | null, groupUuid: string): void {
  if (uid == null || typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(storageKey(uid), groupUuid);
  } catch {
    // 저장 실패는 무시한다.
  }
}

// 유효 선택을 정한다. 딥링크(URL ?group=) → 기억된 마지막 팀 → 첫 그룹 순서다. 목록이 비면 null 이다.
export function resolveSelectedGroupUuid(
  items: readonly TrainingGroupRef[],
  urlGroupUuid: string | null,
  rememberedUuid: string | null,
): string | null {
  if (items.length === 0) {
    return null;
  }
  const fromUrl = items.find((group) => group.group_uuid === urlGroupUuid);
  if (fromUrl) {
    return fromUrl.group_uuid;
  }
  const remembered = items.find((group) => group.group_uuid === rememberedUuid);
  if (remembered) {
    return remembered.group_uuid;
  }
  return items[0].group_uuid;
}
